






import Vue from 'vue';
export default Vue.extend({
    name: 'DvSkeleton',
    props: {
        variant: { type: String as () => 'card' | 'text' | 'detail', default: 'card' },
        count: { type: Number, default: 6 },
        //  When set (card variant), fill the visible viewport with tiles instead
        //  of a fixed count, so the loading grid covers the page rather than one row.
        fill: { type: Boolean, default: false },
    },
    data() {
        return { fillCount: 0 };
    },
    computed: {
        renderCount(): number {
            return this.fill && this.fillCount ? this.fillCount : this.count;
        },
    },
    mounted() {
        if (this.fill && this.variant === 'card') {
            this.$nextTick(() => this.computeFill());
        }
    },
    methods: {
        //  Estimate columns from the grid's own width and rows from the space
        //  left below it in the viewport; mirrors the CSS minmax(280px,1fr)/8px gap.
        computeFill() {
            const el = this.$el as HTMLElement;
            if (!el) return;
            const gap = 8;
            const width = el.clientWidth || window.innerWidth;
            const cols = Math.max(1, Math.floor((width + gap) / (280 + gap)));
            const top = el.getBoundingClientRect().top;
            const tileH = 96 + gap;
            const rows = Math.max(2, Math.ceil((window.innerHeight - top) / tileH));
            this.fillCount = Math.min(cols * rows, 60);
        },
    },
});
